import "~style/components/video/_video.scss";

/**
 * Video play functionality for multiple videos on a page
 *
 * This component handles the play button click event to start the video and hide the thumbnail and play button.
 *
 */

const Video = {
  _selectors: {
    video: ".js-video-block",
    playButton: ".video-block__play",
    thumbnail: ".video-block__video-thumbnail",
    iframe: "iframe",
  },

  init() {
    const self = this;
    
    document.addEventListener("click", ({ target }) => {
      const video = target.closest(self._selectors.video);
      if (target.matches(self._selectors.playButton)) {
        self._playVideo(video);
      } else if (video) {
        self._stopVideo(video);
      }
    });
  },

  _playVideo(video) {
    const iframe = video.querySelector(this._selectors.iframe);
    const src = iframe.getAttribute('src');

    video.classList.add("video--play");

    if (src.includes("vimeo")) {
      iframe.contentWindow.postMessage('{"method":"play","value":"true"}', "*");
    } else if (src.includes("youtube")) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
    }

    const playButton = video.querySelector(this._selectors.playButton);
    const thumbnail = video.querySelector(this._selectors.thumbnail);

    if (playButton) {
      playButton.classList.add("hidden");
    }

    if (thumbnail) {
      thumbnail.classList.add("hidden");
    }
  },

  _stopVideo(video) {
    const iframe = video.querySelector(this._selectors.iframe);
    const src = iframe.getAttribute('src');

    video.classList.remove("video--play");

    if (src.includes("vimeo")) {
      iframe.contentWindow.postMessage('{"method":"pause","value":"true"}', "*");
    } else if (src.includes("youtube")) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }

    const playButton = video.querySelector(this._selectors.playButton);
    const thumbnail = video.querySelector(this._selectors.thumbnail);

    if (playButton) {
      playButton.classList.remove("hidden");
    }

    if (thumbnail) {
      thumbnail.classList.remove("hidden");
    }
  },
};

export default Video;
